import Component from '@glimmer/component';
import AditoolsMenuTabs from './aditools-menu-tabs.ts';

interface AditoolsTabBarSignature {
  Element: HTMLMenuElement;
  Blocks: {
    default: [
      {
        'menu-tabs': typeof AditoolsMenuTabs;
      }
    ];
  };
}

export default class AditoolsTabBar extends Component<AditoolsTabBarSignature> {
  menuTabsClass = AditoolsMenuTabs;
}
